import { amplifyProxy, directApi } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    unpaidInvoices: '',
    loading: {
      invoices: false,
      export: false
    },
    error: {
      invoices: null,
      export: null
    }
  },
  mutations: {
    SET_UNPAID_INVOICES(state, data) {
      state.unpaidInvoices = data
    },
    SET_LOADING(state, { type, value }) {
      state.loading[type] = value
    },
    SET_ERROR(state, { type, error }) {
      state.error[type] = error
    }
  },
  actions: {
    async getUnpaidInvoices({ commit, rootState }) {
      commit('SET_LOADING', { type: 'invoices', value: true })
      commit('SET_ERROR', { type: 'invoices', error: null })
      
      try {
        const endpoint = `/${rootState.user.ClientName}/reporting/invoices/unpaid`
        const options = {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        commit('SET_UNPAID_INVOICES', response.data.Data)
        return response.data.Data
      } catch (error) {
        commit('SET_ERROR', { type: 'invoices', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'invoices', value: false })
      }
    },

    async exportUnpaidInvoices({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'export', value: true })
      commit('SET_ERROR', { type: 'export', error: null })

      try {
        const endpoint = `/${rootState.user.ClientName}/reporting/invoices/unpaid/export`
        const queryParams = {
          branchID: rootState.branchID,
          ...(payload && { monthToSearch: payload })
        }

        await directApi.exportCsv(
          rootState.user.ClientName,
          endpoint,
          queryParams,
          'unpaidInvoiceExport.CSV',
          rootState.user.LoginToken
        )

        return { success: true }
      } catch (error) {
        commit('SET_ERROR', { type: 'export', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'export', value: false })
      }
    }
  }
}